const WA_NUMBER = '15551234567';
export const site = {
  phone: '+91 98765 43210',
  email: 'hello@havenfield.example',
  address: 'Bandra West, Mumbai, India',
};
export function waLink(message) {
  const text = encodeURIComponent(message || '');
  return `https://wa.me/${WA_NUMBER}?text=${text}`;
}
